import { Stack } from '@mui/material';
import { TagCenterCard } from '../../tags-center/TagCenterCard';
import { TagRow } from '../../tags-center/types';
import { SubPageTypes } from '../../types';
import { SelectedObjectCards } from '../../selected-object/list-mode/SelectedObjectCards';
import { useMemo } from 'react';
import { ConfigurationItem } from '../../../parser/ParserTypes';

interface CardRendererProps<T> {
  items: T[];
  pageType: SubPageTypes;
  crmOrgId: string;
}

export const CardRenderer = <T,>({ items, pageType, crmOrgId }: CardRendererProps<T>) => {
  const renderCards = useMemo(() => {
    switch (pageType) {
      case SubPageTypes.objects:
        return <SelectedObjectCards crmOrgId={crmOrgId} items={items as ConfigurationItem[]} />;

      case SubPageTypes.tags:
      case SubPageTypes.users:
        return (
          <>
            {items.map((item) => {
              const tagRow = item as TagRow;
              return (
                <TagCenterCard
                  key={tagRow.id}
                  item={tagRow}
                  crmOrgId={crmOrgId}
                  pageType={pageType}
                />
              );
            })}
          </>
        );

      default:
        return null;
    }
  }, [pageType, crmOrgId, items]);

  return (
    <Stack width="100%" height="100%" overflow="auto">
      {renderCards}
    </Stack>
  );
};
